import { DiaryEvent } from "./diary-event"

export class DiaryEventGroup {
  GroupName: string;
  DiaryEvents: DiaryEvent[];
}
